import React from 'react';
import TabContainer from '../../../../../../../../common/components/tab/containers/tab.containers';
import GatewayCockpitInsightBasicInfoComponent from './insights-basic-info.component';

export const GatewayCockpitInsightComponent = ({
    selectedInsightsEdges, back
}: any) => {

    const tabItems = [
        {
            id: 1,
            title: 'Edge Details',
            component: <GatewayCockpitInsightBasicInfoComponent
            selectedInsightsEdges={selectedInsightsEdges}
            />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end pb-10'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2"
                >
                    Back
                </button>
            </div>
        </div>
    )
}

export default GatewayCockpitInsightComponent;
